var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-off"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.10835 2.07473C1.86418 1.83056 1.46868 1.83056 1.2246 2.07473C0.980514 2.31889 0.980431 2.71439 1.2246 2.95848L5.1036 6.83756C3.85993 7.79798 2.6901 9.12006 1.66643 10.85C4.96176 16.4189 9.72143 17.9894 13.8494 15.5834L17.8913 19.6252C18.0133 19.7473 18.1728 19.8083 18.3332 19.8083C18.4935 19.8083 18.653 19.7473 18.7751 19.6252C19.0193 19.3811 19.0193 18.9856 18.7751 18.7415L2.10835 2.07473ZM9.99976 13.35C8.61901 13.35 7.49976 12.2307 7.49976 10.85C7.49976 10.3871 7.63401 9.95906 7.85335 9.58731L11.2624 12.9964C10.8907 13.2156 10.4626 13.35 9.99976 13.35ZM18.3331 10.85C17.7009 11.9183 17.0113 12.8262 16.286 13.6011L7.99418 5.30923C11.6383 4.25106 15.5198 6.09548 18.3331 10.85Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.4c132901cf5c4e1757da34e09ddffbfa.svg";
export { ForwardRef as ReactComponent };